import { createSlice } from '@reduxjs/toolkit';
import Strings from '@/constants/String';
import BaseApiState from '@/api/BaseApiState';
import { getStaticPaymentFeeDetails,getGlobalPlatformOffers, rescheduleBooking, createBooking,DBLcreateBooking,initPaymentForPendingBooking, cancelBooking, verifyPayment, cancelPendingBooking ,getPlatformOffers,getDBLPlatformOffers,previewBookingPriceAferCouponApplied,previewDBLBookingPriceAferCouponApplied} from "../thunkMidddleware/paymentMiddleware";


const initialState = {
    isPaymentProcessing:false,
    showPaymentSuccessAnimation:false,

    staticPaymentFeeDetails: BaseApiState,
    createBookingDetails: BaseApiState,
    initPaymentForPendingBookingResponse:BaseApiState,
    verifyPaymentDetails: BaseApiState,
    cancelBookingDetails: BaseApiState,
    cancelPendingBookingDetails: BaseApiState,
    getPlatformOffersResponse:BaseApiState,
    previewBookingPriceAferCouponAppliedResponse:BaseApiState,
    rescheduleBookingResponse:BaseApiState,
    getGlobalPlatformOffersResponse:BaseApiState
    

};


const paymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {
        setIsPaymentProcessing:(state, action) => {
            state.isPaymentProcessing= action.payload || false
        },
        setShowPaymentSuccessAnimation:(state, action) => {
            state.showPaymentSuccessAnimation= action.payload || false
        },
        getpaymentconfig: (state, action) => {

        },
        resetVerifyPaymentDetails: (state) => {
            state.verifyPaymentDetails = BaseApiState
        },
        resetPriceAferCouponApplied: (state) => {
            state.previewBookingPriceAferCouponAppliedResponse = BaseApiState
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getStaticPaymentFeeDetails.pending, (state) => {
                state.staticPaymentFeeDetails.isLoading = true;
                state.staticPaymentFeeDetails.error = null;
            })
            .addCase(getStaticPaymentFeeDetails.fulfilled, (state, action) => {
                state.staticPaymentFeeDetails.isLoading = false;
                state.staticPaymentFeeDetails.success = action.payload?.success;
                state.staticPaymentFeeDetails.payload = action.payload?.payload;
            })
            .addCase(getStaticPaymentFeeDetails.rejected, (state, action) => {
                state.staticPaymentFeeDetails.isLoading = false;
                state.staticPaymentFeeDetails.error = action.error as string;
                state.staticPaymentFeeDetails.payload = null
            });

        builder
            .addCase(createBooking.pending, (state) => {
                state.createBookingDetails.isLoading = true;
                state.createBookingDetails.error = null;
            })
            .addCase(createBooking.fulfilled, (state, action) => {
                state.createBookingDetails.isLoading = false;
                state.createBookingDetails.success = action.payload?.success;
                state.createBookingDetails.payload = action.payload?.payload;
            })
            .addCase(createBooking.rejected, (state, action) => {
                state.createBookingDetails.isLoading = false;
                state.createBookingDetails.error = action.error as string;
                state.createBookingDetails.payload = null
            });
//--------------------------------------------------------------------------------------
        builder
        .addCase(DBLcreateBooking.pending, (state) => {
            state.createBookingDetails.isLoading = true;
            state.createBookingDetails.error = null;
        })
        .addCase(DBLcreateBooking.fulfilled, (state, action) => {
            state.createBookingDetails.isLoading = false;
            state.createBookingDetails.success = action.payload?.success;
            state.createBookingDetails.payload = action.payload?.payload;
        })
        .addCase(DBLcreateBooking.rejected, (state, action) => {
            state.createBookingDetails.isLoading = false;
            state.createBookingDetails.error = action.error as string;
            state.createBookingDetails.payload = null
        });
//--------------------------------------------------------------------------------------

        builder
        .addCase(rescheduleBooking.pending, (state) => {
            state.rescheduleBookingResponse.isLoading = true;
            state.rescheduleBookingResponse.error = null;
        })
        .addCase(rescheduleBooking.fulfilled, (state, action) => {
            state.rescheduleBookingResponse.isLoading = false;
            state.rescheduleBookingResponse.success = action.payload?.success;
            state.rescheduleBookingResponse.payload = action.payload?.payload;
        })
        .addCase(rescheduleBooking.rejected, (state, action) => {
            state.rescheduleBookingResponse.isLoading = false;
            state.rescheduleBookingResponse.error = action.error as string;
            state.rescheduleBookingResponse.payload = null
        });

//--------------------------------------------------------------------------------------
        builder
        .addCase(getPlatformOffers.pending, (state) => {
            state.getPlatformOffersResponse.isLoading = true;
            state.getPlatformOffersResponse.error = null;
        })
        .addCase(getPlatformOffers.fulfilled, (state, action) => {
            state.getPlatformOffersResponse.isLoading = false;
            state.getPlatformOffersResponse.success = action.payload?.success;
            state.getPlatformOffersResponse.payload = action.payload?.payload;
        })
        .addCase(getPlatformOffers.rejected, (state, action) => {
            state.getPlatformOffersResponse.isLoading = false;
            state.getPlatformOffersResponse.error = action.error as string;
            state.getPlatformOffersResponse.payload = null
        });

        //--------------------------------------------------------------------------------------
                    builder
                    .addCase(getGlobalPlatformOffers.pending, (state:any) => {
                        state.getGlobalPlatformOffersResponse.isLoading = true;
                        state.getGlobalPlatformOffersResponse.error = null;
                    })
                    .addCase(getGlobalPlatformOffers.fulfilled, (state:any, action:any) => {
                        state.getGlobalPlatformOffersResponse.isLoading = false;
                        state.getGlobalPlatformOffersResponse.success = action.payload?.success;
                        state.getGlobalPlatformOffersResponse.payload = action.payload?.payload;
                    })
                    .addCase(getGlobalPlatformOffers.rejected, (state:any, action:any) => {
                        state.getGlobalPlatformOffersResponse.isLoading = false;
                        state.getGlobalPlatformOffersResponse.error = action.error as string;
                        state.getGlobalPlatformOffersResponse.payload = null
                    });



        //--------------------------------------------------------------------------------------
        builder
        .addCase(getDBLPlatformOffers.pending, (state) => {
            state.getPlatformOffersResponse.isLoading = true;
            state.getPlatformOffersResponse.error = null;
        })
        .addCase(getDBLPlatformOffers.fulfilled, (state, action) => {
            state.getPlatformOffersResponse.isLoading = false;
            state.getPlatformOffersResponse.success = action.payload?.success;
            state.getPlatformOffersResponse.payload = action.payload?.payload;
        })
        .addCase(getDBLPlatformOffers.rejected, (state, action) => {
            state.getPlatformOffersResponse.isLoading = false;
            state.getPlatformOffersResponse.error = action.error as string;
            state.getPlatformOffersResponse.payload = null
        });
//--------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------
        builder
        .addCase(previewBookingPriceAferCouponApplied.pending, (state) => {
            state.previewBookingPriceAferCouponAppliedResponse.isLoading = true;
            state.previewBookingPriceAferCouponAppliedResponse.error = null;
        })
        .addCase(previewBookingPriceAferCouponApplied.fulfilled, (state, action) => {
            state.previewBookingPriceAferCouponAppliedResponse.isLoading = false;
            state.previewBookingPriceAferCouponAppliedResponse.success = action.payload?.success;
            state.previewBookingPriceAferCouponAppliedResponse.payload = action.payload?.payload;
        })
        .addCase(previewBookingPriceAferCouponApplied.rejected, (state, action) => {
            state.previewBookingPriceAferCouponAppliedResponse.isLoading = false;
            state.previewBookingPriceAferCouponAppliedResponse.error = action.error as string;
            // state.previewBookingPriceAferCouponAppliedResponse.payload = null
        });
        //--------------------------------------------------------------------------------------
        builder
        .addCase(previewDBLBookingPriceAferCouponApplied.pending, (state) => {
            state.previewBookingPriceAferCouponAppliedResponse.isLoading = true;
            state.previewBookingPriceAferCouponAppliedResponse.error = null;
        })
        .addCase(previewDBLBookingPriceAferCouponApplied.fulfilled, (state, action) => {
            state.previewBookingPriceAferCouponAppliedResponse.isLoading = false;
            state.previewBookingPriceAferCouponAppliedResponse.success = action.payload?.success;
            state.previewBookingPriceAferCouponAppliedResponse.payload = action.payload?.payload;
        })
        .addCase(previewDBLBookingPriceAferCouponApplied.rejected, (state, action) => {
            state.previewBookingPriceAferCouponAppliedResponse.isLoading = false;
            state.previewBookingPriceAferCouponAppliedResponse.error = action.error as string;
        });
//--------------------------------------------------------------------------------------

            builder
            .addCase(initPaymentForPendingBooking.pending, (state) => {
                state.initPaymentForPendingBookingResponse.isLoading = true;
                state.initPaymentForPendingBookingResponse.error = null;
            })
            .addCase(initPaymentForPendingBooking.fulfilled, (state, action) => {
                state.initPaymentForPendingBookingResponse.isLoading = false;
                state.initPaymentForPendingBookingResponse.success = action.payload?.success;
                state.initPaymentForPendingBookingResponse.payload = action.payload?.payload;
            })
            .addCase(initPaymentForPendingBooking.rejected, (state, action) => {
                state.initPaymentForPendingBookingResponse.isLoading = false;
                state.initPaymentForPendingBookingResponse.error = action.error as string;
                state.initPaymentForPendingBookingResponse.payload = null
            });

//-----------------------------------------------------------------------------------------
        builder
            .addCase(cancelBooking.pending, (state) => {
                state.cancelBookingDetails.isLoading = true;
                state.cancelBookingDetails.error = null;
            })
            .addCase(cancelBooking.fulfilled, (state, action) => {
                state.cancelBookingDetails.isLoading = false;
                state.cancelBookingDetails.success = action.payload?.success;
                state.cancelBookingDetails.payload = action.payload?.payload;
            })
            .addCase(cancelBooking.rejected, (state, action) => {
                state.cancelBookingDetails.isLoading = false;
                state.cancelBookingDetails.error = action.error as string;
                state.cancelBookingDetails.payload = null
            });
        builder
            .addCase(verifyPayment.pending, (state) => {
                state.verifyPaymentDetails.isLoading = true;
                state.verifyPaymentDetails.error = null;
            })
            .addCase(verifyPayment.fulfilled, (state, action) => {
                state.verifyPaymentDetails.isLoading = false;
                state.verifyPaymentDetails.success = action.payload?.success
                state.verifyPaymentDetails.payload = action.payload?.payload;
            })
            .addCase(verifyPayment.rejected, (state, action) => {
                state.verifyPaymentDetails.isLoading = false;
                state.verifyPaymentDetails.error = action.error as string;
                state.verifyPaymentDetails.payload = null
            });

        builder
            .addCase(cancelPendingBooking.pending, (state) => {
                state.cancelPendingBookingDetails.isLoading = true;
                state.cancelPendingBookingDetails.error = null;
            })
            .addCase(cancelPendingBooking.fulfilled, (state, action) => {
                state.cancelPendingBookingDetails.isLoading = false;
                state.cancelPendingBookingDetails.success = action.payload?.success
                state.cancelPendingBookingDetails.payload = action.payload?.payload;
            })
            .addCase(cancelPendingBooking.rejected, (state, action) => {
                state.cancelPendingBookingDetails.isLoading = false;
                state.cancelPendingBookingDetails.error = action.error as string;
                state.cancelPendingBookingDetails.payload = null
            });
    }
});


export const { setIsPaymentProcessing,setShowPaymentSuccessAnimation,resetPriceAferCouponApplied,getpaymentconfig, resetVerifyPaymentDetails } = paymentSlice.actions;

export default paymentSlice.reducer;